import axiosClient from './axiosClient';

const authService = {
    login: (username, password) => axiosClient.post('/auth/login', { username, password }),
    
    sendEmailOtp: (email) => axiosClient.post('/auth/send-email-otp', { email }),

    register: (userData) => axiosClient.post('/auth/register', {
        username: userData.username,
        password: userData.password,
        accountName: userData.accountName,
        phone: userData.phone,
        email: userData.email,
        role: userData.role,
        otp: userData.otp      
    }),

    // 👉 THÊM API NÀY ĐỂ GỬI TOKEN GOOGLE XUỐNG BACKEND
    googleLogin: (token) => axiosClient.post('/auth/google-login', { token }),

    checkAccountStatus: (username) => axiosClient.get(`/auth/account-status/${username}`),

    logout: () => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('user_info');
    }
};

export default authService;